import API from "api/axiosInstance";
import {
  setIsLoading,
  setListPerkiraan,
  setListTransaksi,
  setListTransaksiWarkat,
  setMessage,
  setStatus,
} from "./index";

export const fetchListTransaksiWarkat = () => async (dispatch) => {
  try {
    const response = await API.get("/keuangan/list-transaksi-warkat");
    dispatch(setListTransaksiWarkat(response.data.data));
  } catch (error) {
    dispatch(setStatus("failed"));
  }
};

export const postListTransaksiWarkat = (reqData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post("/keuangan/list-transaksi-warkat", reqData);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(
      setMessage(error?.response?.data?.message ?? "Ada Kendala di Server"),
    );
    dispatch(setStatus("failed"));
  }
};

export const fetchListTransaksi = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get("/keuangan/list-transaksi");
    dispatch(setIsLoading(false));
    dispatch(setListTransaksi(response.data.data));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchListPerkiraan = () => async (dispatch) => {
  try {
    const response = await API.get("/keuangan/list-perkiraan");
    dispatch(setListPerkiraan(response.data.data));
  } catch (error) {
    dispatch(setStatus("failed"));
  }
};

export const deleteListTransaksiWarkat = (id) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.delete(
      `/keuangan/delete-list-transaksi-warkat/${id}`,
    );
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const editTanggalListTransaksiWarkat = (reqData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post(
      `/keuangan/edit-tanggal-list-transaksi-warkat`,
      reqData,
    );
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const realisasiListTransaksiWarkat = (reqData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.put(
      `/keuangan/realisasi-list-transaksi-warkat`,
      reqData,
    );
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};
